import React, { useEffect, useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { purchases } from '../data/landing';
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        cycleTimer = window.setTimeout(show, 28000 + Math.floor(Math.random() * 14000));
      }, 5000);
    };
    const initialTimer = window.setTimeout(show, 15000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <aside aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-50 w-[calc(100%-2rem)] max-w-sm" data-id="element-185" data-mp="163wcurvqm02b">
      <AnimatePresence data-id="element-186" data-mp="1fwbx5vuib0qd">
        {visible && <motion.div initial={{
        x: -24,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -24,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative border border-gold-dark/20 bg-white p-4 pr-10 shadow-2xl" data-id="element-187" data-mp="1fv0s7spbrmxo">
            <button type="button" aria-label="Dismiss recent purchase notification" onClick={() => setDismissed(true)} className="absolute right-2 top-2 p-1 text-slate-500 transition-colors duration-150 ease-out hover:text-ink" data-id="element-188" data-mp="x5153bd1ohww">
              <XIcon className="h-4 w-4" data-id="element-189" data-mp="23lmybefrqx51" />
            </button>
            <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-gold-deeper" data-id="element-190" data-mp="23nhc88smhozm">
              <span className="grid h-4 w-4 place-items-center rounded-full bg-cta-shadow" data-id="element-191" data-mp="2fno139kjn9zm">
                <CheckIcon className="h-3 w-3 text-white" data-id="element-192" data-mp="2fphagwmjk8bb" />
              </span>
              Verified purchase
            </p>
            <p className="mt-3 text-sm font-semibold text-ink" data-id="element-193" data-mp="2pmdil18j2sfc">
              <strong data-id="element-194" data-mp="2pjhmlig8qdtj">{purchase.name}</strong> from {purchase.location}
            </p>
            <p className="mt-1 text-xs font-medium text-slate-600" data-id="element-195" data-mp="1rzwm1y7mciun">
              just purchased{' '}
              <span className="font-bold text-gold-deeper" data-id="element-196" data-mp="1wv29x2kl07ld">
                {purchase.product}
              </span>
            </p>
          </motion.div>}
      </AnimatePresence>
    </aside>;
}